import React, {Suspense} from 'react';

const ProductWarrantyComponent = React.lazy(() => import('../Component/ProductWarranty/ProductWarrantyComponent'));

function ProductWarrantyPage(props) {
    return (
        <>
            <Suspense fallback={<div>Loading...</div>}>
                <ProductWarrantyComponent/>
            </Suspense>
        </>
    );
}

export default ProductWarrantyPage;